module.exports = __webpack_public_path__ + "/img/aviva.c386bb0203e611eaca8b0d4693910e0e.jpg";